import React from 'react'
import { useFieldArray } from 'react-hook-form'
import { Content, Label } from './styles'
import { Row } from '../../../../../components/commons'
import Input from '../../../../../components/Input'
import useToast from '../../../../../hooks/useToast'
import { ButtonRound } from '../../../../../components/Header/styles'
import { FaPlus, FaUpload, FaXmark } from 'react-icons/fa6'

export interface MetaDataInputProps {
  control: any
  label?: string
  error?: any
  setError: any
  getValues: any
  disabled?: boolean
  name: string
}

const MetaDataInput: React.FunctionComponent<MetaDataInputProps> = ({
  control,
  setError,
  getValues,
  label,
  disabled,
  error,
  name,
}) => {
  const toast = useToast()
  const inputRef = React.useRef<any>(null)

  const { fields, append, remove } = useFieldArray({
    control,
    name: name,
  })

  const handleChange = (e: any) => {
    if (e.target.files.length) {
      e.persist()

      let file = e.target.files[0]

      let fr = new FileReader()
      fr.onload = function () {
        let fileValue = fr.result
        remove()

        const lines = String(fileValue).split(';')
        lines.forEach((line) => {
          const attr = line.split(',')

          let fieldFormated = attr[0].replace(/\r\n/g, '')
          if (fieldFormated !== '') {
            append({
              name: fieldFormated,
            })
          }
        })
        append({
          name: '',
        })
      }

      fr.readAsText(file, 'ISO-8859-1')
    }
  }
  const addValue = (index: number) => {
    let value = getValues('metadata')[index]
    if (value.name !== '') {
      append({ name: '' })
    } else {
      setError(`${name}.${index}.name`, { type: 'custom', message: 'Preencha o campo' })
    }
  }

  const removeValue = (index: number) => {
    remove(index)
  }

  React.useEffect(() => {
    append({ name: '' })
  }, [])

  return (
    <Content>
      {label && (
        <Row align='center' gap={10}>
          <Label>{label} </Label>
          <input
            id='file'
            ref={inputRef}
            onChange={handleChange}
            accept={'.txt'}
            type='file'
            hidden
            name='file'
          />
          <ButtonRound onClick={() => inputRef.current && inputRef.current.click()}>
            <FaUpload color='white' size={15} />
          </ButtonRound>
        </Row>
      )}

      {fields.map((cp: any, index: number) => {
        if (cp.name === '') {
          let errorValue = error && typeof error[index] !== 'undefined' ? error[index].name : ''

          return (
            <Row gap={15} style={{ width: '100%' }}>
              <div style={{ width: '100%' }}>
                <Input
                  control={control}
                  label={`#${index + 1}`}
                  error={errorValue}
                  button={
                    <ButtonRound
                      style={{ width: 30, height: 30, minWidth: 30, minHeight: 30, margin: 'auto' }}
                      onClick={() => addValue(index)}
                    >
                      <FaPlus color='white' size={25} />
                    </ButtonRound>
                  }
                  placeholder='Digite um campo'
                  name={`${name}.${index}.name`}
                  type='text'
                />
              </div>
            </Row>
          )
        }

        return (
          <Input
            control={control}
            disabled
            button={
              <ButtonRound
                style={{ width: 30, height: 30, minWidth: 30, minHeight: 30, margin: 'auto' }}
                onClick={() => removeValue(index)}
              >
                <FaXmark color='white' size={25} />
              </ButtonRound>
            }
            label={`#${index + 1}`}
            name={`${name}.${index}.name`}
            type='text'
          />
        )
      })}
    </Content>
  )
}

export default MetaDataInput
